<div *ngIf="jobModel" class="job-edit-wrapper" style="padding-left: 15px">
    <slick-container-body>

        <slick-tabs [(tabIndex)]="tabIndex" (tabChange)="onTabChanged($event)">
            <slick-tab header="Job" icon="bi bi-clipboard-fill">
                <slick-container maxHeight="calc(100vh - 280px)" [padding]="!isDialog">

                    <slick-container-body>
                        <div class="d-flex flex-fill flex-column mb-3">
                            <div class="bold-header mb-2 mt-1" style="display: flex; align-items: center; padding-top: 5px !important;">
                                <div style="flex-grow: 1;">Job Info</div>
                                <div class="gray-line"></div>
                            </div>
                            <div class="d-flex flex-fill job-customer-row">
                                <div class="me-1" *ngIf="!jobModel.showOneTimeAddress" style="flex: 1;">
                                    <label style="padding-bottom: 3px;">
                                        Job Site Customer&nbsp;
                                        <button *ngIf="useOneTimeAddress"
                                                type="button"
                                                style="font-size: 10px; margin-top: -2px !important;"
                                                class="btn btn-link p-0 m-0"
                                                (click)="swapJobSiteCustomer()">
                                            <i class="far fa-sync"></i>
                                        </button>
                                    </label>
                                    <customer-search [(customerModel)]="jobModel.jobCustomer"
                                                     [customerMultiAddress]="jobModel.customerMultipleAddress"
                                                     (customerMultiAddressChange)="onMultiAddressChange($event)"
                                                     showSearchIcon="false"
                                                     [showCustomerDisplay]="!jobModel.customerMultipleAddress"
                                                     [valType]="true"
                                                     [submitted]="isSubmitted"
                                                     [showButtons]="!isQPro"
                                                     [includeMultiAddress]="true"
                                                     [disableButtons]="!jobsAuthService.canEdit()"
                                                     [showTaxRegionPopUp]="false"
                                                     [ngClass]="{'error-search': !jobModel.jobCustomer && isSubmitted && jobModel.showJobSiteCustomer}"></customer-search>
                                    <form-error *ngIf="!jobModel.jobCustomer && isSubmitted && jobModel.showJobSiteCustomer">The Job Site Customer is required</form-error>
                                </div>


                                <div class="mt-1 ms-1 me-3 arrow-button" *ngIf="!jobModel.showOneTimeAddress && !jobModel.customerMultipleAddress">
                                    <label>&nbsp;</label>
                                    <button type="button" class="btn btn-outline-primary"
                                            [disabled]="!jobModel.jobCustomer || !jobsAuthService.canEdit()"
                                            (click)="jobModel.billToCustomer = jobModel.jobCustomer">
                                        <i class="fa fa-arrow-right"></i>
                                    </button>
                                </div>

                                <div class="me-3" *ngIf="jobModel.showOneTimeAddress" style="flex: 1;">
                                    <label style="padding-bottom: 1px;">
                                        Job Site Address&nbsp;
                                        <button *ngIf="useOneTimeAddress"
                                                type="button"
                                                style="font-size: 10px;"
                                                class="btn btn-link p-0 m-0"
                                                (click)="swapJobSiteCustomer()">
                                            <i class="far fa-sync"></i>
                                        </button>
                                    </label>

                                    <div class="d-flex flex-fill align-items-center position-relative">
                                        <input type="text"
                                               class="form-control"
                                               name="addressSearch"
                                               [slick-validation-indicator]="jobModel.oneTimeAddress?.address1"
                                               slickValidationType="error"
                                               slick-google-address-search
                                               (onGoogleAddressSelect)="onGoogleMapAddressSelect($event)" />
                                        <div class="d-flex position-absolute top-50 translate-middle-y end-0">
                                            <div class="slick-search-bar_add-button me-2">
                                                <a href="#" *ngIf="!disableAddButton" (click)="showNewAddressDialog(); false;"><i class="far fa-plus"></i></a>
                                            </div>
                                            <div class="slick-search-bar_edit-button me-2" *ngIf="jobModel?.oneTimeAddress?.address1">
                                                <a href="#" (click)="showEditAddressDialog(); false;"><i class="far fa-pencil"></i></a>
                                            </div>
                                            <div class="slick-search-bar_edit-button me-2">
                                                <div *ngIf="!jobModel?.oneTimeAddress?.address1 && !jobModel?.oneTimeAddress?.address2 && !jobModel?.oneTimeAddress?.city
													&& !jobModel?.oneTimeAddress?.state && !jobModel?.oneTimeAddress?.zipcode && !jobModel?.oneTimeAddress?.country"><i class="far fa-pencil"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                    <form-error *ngIf="!jobModel.oneTimeAddress?.address1 && isSubmitted && jobModel.showOneTimeAddress">The Job Site Address is required</form-error>

                                    <ul class="address-list-item">
                                        <li *ngIf="jobModel?.oneTimeAddress?.address1 || jobModel?.oneTimeAddress?.address2 || jobModel?.oneTimeAddress?.city
										|| jobModel?.oneTimeAddress?.state || jobModel?.oneTimeAddress?.zipcode || jobModel?.oneTimeAddress?.country"></li>
                                        <li *ngIf="jobModel?.oneTimeAddress?.address1">{{ jobModel.oneTimeAddress.address1 }}</li>
                                        <li *ngIf="jobModel?.oneTimeAddress?.address2">{{ jobModel.oneTimeAddress.address2 }}</li>
                                        <li>
                                            <span *ngIf="jobModel?.oneTimeAddress?.city">{{ jobModel.oneTimeAddress.city }}, </span>
                                            <span *ngIf="jobModel?.oneTimeAddress?.state">{{ jobModel.oneTimeAddress.state }}, </span>
                                            <span *ngIf="jobModel?.oneTimeAddress?.zipcode">{{ jobModel.oneTimeAddress.zipcode }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="!jobModel.showOneTimeAddress" style="flex: 1;">
                                    <label style="padding-bottom: 3px;">Billing Customer</label>
                                    <customer-search [(customerModel)]="jobModel.billToCustomer"
                                                     [isBillingCustomer]="true"
                                                     [showButtons]="!isQPro"
                                                     [valType]="true"
                                                     [includeMultiAddress]="false"
                                                     [disableButtons]="!jobsAuthService.canEdit()"
                                                     [showTaxRegionPopUp]="false"
                                                     [ngClass]="{'error-search': !jobModel.billToCustomer && isSubmitted}"></customer-search>
                                    <form-error *ngIf="!jobModel.billToCustomer && isSubmitted">Billing Customer is required</form-error>
                                </div>

                                <div *ngIf="jobModel.showOneTimeAddress" style="flex: 1;">
                                    <label style="padding-bottom: 3px;">Billing Customer</label>
                                    <customer-search [(customerModel)]="jobModel.billToCustomer"
                                                     [isBillingCustomer]="true"
                                                     [valType]="requireBillToCustomer"
                                                     [showButtons]="!isQPro"
                                                     [valType]="true"
                                                     [includeMultiAddress]="false"
                                                     [disableButtons]="!jobsAuthService.canEdit()"
                                                     [showTaxRegionPopUp]="false"
                                                     [ngClass]="{'error-search': !jobModel.billToCustomer && isSubmitted}"></customer-search>
                                    <form-error *ngIf="!jobModel.billToCustomer && isSubmitted">Billing Customer is required</form-error>
                                </div>
                            </div>

                            <div class="d-flex flex-fill mt-3">
                                <div class="flex-fill me-3">
                                    <label>Job Name</label>
                                    <input [(ngModel)]="jobModel.jobName"
                                           [slick-validation-indicator]="jobModel.jobName"
                                           slickValidationType="error"
                                           class="form-control"
                                           type="text"
                                           [ngClass]="{'error-input': !jobModel.jobName && isSubmitted}" />
                                    <form-error *ngIf="!jobModel.jobName && isSubmitted">The Job Name is required</form-error>
                                </div>
                                <div class="me-3 flex-fill">
                                    <label>Job Status</label>
                                    <slick-drop-down [(ngModel)]="jobModel.jobStatusId"
                                                     [items]="jobStatuses"
                                                     [allowEmpty]="false"
                                                     [validationIndicator]="jobModel.jobStatusId"
                                                     (onSelect)="onJobStatusSelected($event)"
                                                     [ngClass]="{'error-input': !jobModel.jobStatusId && isSubmitted}"></slick-drop-down>
                                    <form-error *ngIf="!jobModel.jobStatusId && isSubmitted">The Job Status is required</form-error>
                                </div>
                                <div class="flex-fill">
                                    <label>Job Type</label>
                                    <slick-drop-down [(ngModel)]="jobModel.jobTypeId"
                                                     [items]="jobTypes"
                                                     [allowEmpty]="false"
                                                     [validationIndicator]="jobModel.jobTypeId"
                                                     (onSelect)="onJobTypeSelected($event)"
                                                     [ngClass]="{'error-dropdown': !jobModel.jobTypeId && isSubmitted}"></slick-drop-down>
                                    <form-error *ngIf="!jobModel.jobTypeId && isSubmitted">The Job Type is required</form-error>
                                </div>
                            </div>
                            <div class="d-flex flex-fill mt-3">
                                <div class="w-100 me-3">
                                    <label>Job Instructions</label>
                                    <textarea [(ngModel)]="jobModel.description"
                                              class="form-control"
                                              rows="3"
                                              style="line-height: 1rem;"
                                              type="text"></textarea>
                                </div>

                                <div class="w-100">
                                    <label>Office Notes</label>
                                    <textarea [(ngModel)]="jobModel.jobNotes"
                                              class="form-control"
                                              rows="3"
                                              style="line-height: 1rem;"
                                              type="text"></textarea>
                                </div>

                            </div>
                            <div class="d-flex mt-3 justify-content-end">
                                <div *ngIf="!isQPro" class="me-1 text">
                                    <label>&nbsp;</label>
                                    <div *ngIf="!this.jobModel.invoice || this.jobModel.invoice.invoiceId === 0">
                                        <button *ngIf='isEstimate' class="btn btn-outline-primary btn-sm" (click)="openEstimate()" [disabled]="!jobsAuthService.canEdit()"><i class="far fa-pencil"></i> Create Estimate</button>
                                        <button *ngIf='isSalesOrder' class="btn btn-outline-primary btn-sm" (click)="openSalesOrder()" [disabled]="!jobsAuthService.canEdit()"><i class="far fa-pencil"></i> Create Sales Order</button>
                                        <button *ngIf='isInvoice' class="btn btn-outline-primary btn-sm" (click)="openInvoice()" [disabled]="!jobsAuthService.canEdit()"><i class="far fa-pencil"></i> Create Invoice</button>
                                    </div>
                                    <div *ngIf="this.jobModel.invoice && this.jobModel.invoice.invoiceId !== 0">
                                        <button *ngIf='isEstimate' class="btn btn-outline-primary btn-sm" (click)="openEstimate()" [disabled]="!jobsAuthService.canEdit()"><i class="far fa-pencil"></i> Edit Estimate</button>
                                        <button *ngIf='isSalesOrder' class="btn btn-outline-primary btn-sm" (click)="openSalesOrder()" [disabled]="!jobsAuthService.canEdit()"><i class="far fa-pencil"></i> Edit Sales Order</button>
                                        <button *ngIf='isInvoice' class="btn btn-outline-primary btn-sm" (click)="openInvoice()" [disabled]="!jobsAuthService.canEdit()"><i class="far fa-pencil"></i> Edit Invoice</button>
                                    </div>
                                </div>

                                <div *ngIf="!isQPro" class="me-2">
                                    <label>&nbsp;</label>
                                    <button *ngIf='isEstimate' class="btn btn-outline-primary btn-sm" [disabled]="jobModel.jobId === 0" (click)="linkInvoice()" title="Link existing Sales Order/Invoice"><i class="far fa-link"></i> Link Existing Estimate</button>
                                    <button *ngIf='isSalesOrder' class="btn btn-outline-primary btn-sm" [disabled]="jobModel.jobId === 0" (click)="linkInvoice()" title="Link existing Sales Order/Invoice"><i class="far fa-link"></i> Link Existing Sales Order</button>
                                    <button *ngIf='isInvoice' class="btn btn-outline-primary btn-sm" [disabled]="jobModel.jobId === 0" (click)="linkInvoice()" title="Link existing Sales Order/Invoice"><i class="far fa-link"></i> Link Existing Invoice</button>
                                </div>

                                <div *ngIf="canUsePipeline && jobModel.jobId > 0" class="me-2">
                                    <label>&nbsp;</label>
                                    <button *ngIf="pipelineTicket" class="btn btn-outline-primary btn-sm" (click)="openPipelineTicket()" title="Open this job's Sales Pipeline ticket"><i class="bi bi-kanban"></i> {{pipelineTicket.ticketNumber}}</button>
                                    <button *ngIf="!pipelineTicket" class="btn btn-outline-primary btn-sm" (click)="openAddToPipeline()" [disabled]="!canEditPipeline" title="Create a Sales Pipeline ticket for this job"><i class="far fa-plus"></i> Pipeline</button>
                                </div>
                            </div>
                        </div>

                        <div class="bold-header mb-2 mt-1 mb-2" style="display: flex; align-items: center; padding-top: 5px !important;">
                            <div style="flex-grow: 1;">Appointment Info</div>
                            <div class="gray-line"></div>
                        </div>
                        <!-- <h5 class="border-bottom mt-2"> Appointments</h5> -->
                        <!-- Appointments -->
                        <div class="d-flex flex-column">
                            <div class="d-flex ms-2 me-2 align-items-center">
                                <button class="btn btn-outline-primary btn-sm me-1" (click)="openAutoScheduler()" [disabled]="!jobsAuthService.canEdit()"><i class="fad fa-calendar"></i> Auto-Schedule</button>
                                <button class="btn btn-outline-primary btn-sm me-1" (click)="createNewAppointment()" [disabled]="!jobsAuthService.canEdit()"> <i class="far fa-plus"></i> Appointment</button>
                                <div class="flex-fill"></div>
                                <button class="btn btn-outline-primary btn-sm" *ngIf="canOpenSiteLog" (click)="openSiteLogDialog()"><i class="bi bi-clipboard-check"></i> Site Log</button>
                            </div>
                            <!-- If there is a default appt, show it first and expanded-->
                            <div *ngFor="let appointment of jobModel.appointments;let i=index">
                                <div class="ms-2 me-2 mt-2" *ngIf="!appointment.isDeleted">
                                    <div class="d-flex">

                                        <div class="flex-fill card p-2" *ngIf="!appointment.uiState || appointment.uiState === 'collapsed'">
                                            <div class="d-flex flex-column">
                                                <div class="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <span class="p-0 m-0 border-0" style="font-size: 20px;">{{ appointment.appointmentTypeDisplayName }} | {{ appointment.appointmentStatusDisplayName }}</span>
                                                        <!-- <span class="p-0 ms-1 border-0"> | {{ appointment.appointmentStatusDisplayName }}</span> -->
                                                        <div>
                                                            <h6 class="p-0 m-0 border-0" style="font-weight: 400;">{{ appointment.resourceDisplayName }}</h6>
                                                            <h6 class="p-0 m-0 border-0" style="font-weight: 400;">{{ appointment.scheduledDateTime | date:'M/d/yyyy h:mm a' }}</h6>
                                                        </div>
                                                    </div>
                                                    <button class="btn btn-outline-primary btn-sm state-btn" (click)="expand(i)">
                                                        <i *ngIf="!appointment.uiState || appointment.uiState === 'collapsed'" class="far fa-plus"></i>
                                                    </button>
                                                </div>
                                                <div class="d-flex mt-3 appointment-notes-row">
                                                    <div class="flex-fill me-2" style="min-width: 33%; max-width: 33%; border-right: 2px solid var(--bs-gray-300);">
                                                        <label class="job-label" style="font-size: .7rem;">Appointment instructions</label>
                                                        <div class="ps-2 pe-1">
                                                            {{ appointment.description }}
                                                        </div>
                                                    </div>
                                                    <div class="flex-fill me-2" style="min-width: 33%; max-width: 33%; border-right: 2px solid var(--bs-gray-300);">
                                                        <label class="job-label" style="font-size: .7rem;">Customer Notes</label>
                                                        <div class="ps-2 pe-1">
                                                            {{ appointment.customerNotes }}
                                                        </div>
                                                    </div>
                                                    <div class="flex-fill">
                                                        <label class="job-label" style="font-size: .7rem;">Tech Notes</label>
                                                        <div class="ps-2">
                                                            {{ appointment.notes }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-fill card p-2" *ngIf="appointment.uiState === 'expanded'">
                                            <appointment-edit [appointment]="appointment"
                                                              [customerId]="jobModel.jobCustomer?.customerId"
                                                              [isSalesOrder]="isSalesOrder"
                                                              [isInvoice]="isInvoice"
                                                              [submitted]="isSubmitted"
                                                              [showDeleteButton]="jobModel.appointments.length > 1"
                                                              (onAppointmentDelete)="onAppointmentDelete($event)"
                                                              (onAppointmentPrint)="onAppointmentPrint($event)"
                                                              (onMultiDayAppointmentsAdded)="onMultiDayAppointmentsAdded($event)"
                                                              (onExpandOrCollapse)="onExpandOrCollapse($event,i)"></appointment-edit>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <form-error *ngIf="(jobModel.appointments === null || jobModel.appointments === undefined || jobModel.appointments.length <= 0) && isSubmitted"> At least one appointment is required </form-error>
                        </div>
                    </slick-container-body>
                </slick-container>
            </slick-tab>

            <slick-tab header="Photos" icon="bi bi-camera-fill far" *ngIf="jobModel.jobId > 0">
                <slick-container maxHeight="calc(100vh - 280px)">
                    <slick-container-body>

                        <!-- this top one is just for the file drop, added this so that we could have the same order on all tabs -->
                        <documents-edit *ngIf="tabKey === 'Photos'"
                                        [documentKey]="jobModel.documentKey"
                                        documentType="Jobs"
                                        folderType="photos"
                                        [canDelete]="true"
                                        [hideList]="true"
                                        (onAdd)="onFilesAdded()"
                                        [hideFileDrop]="!jobsAuthService.canEdit()"></documents-edit>

                        <documents-edit *ngIf="tabKey === 'Photos'"
                                        title="Customer Photos"
                                        [documentKey]="jobModel.jobCustomer.documentKey"
                                        documentType="Customers"
                                        folderType="photos"
                                        [canDelete]="false"
                                        [allowTitleEditing]="jobsAuthService.canEdit()"
                                        [hideFileDrop]="true"></documents-edit>

                        <documents-edit #jobFileList
                                        *ngIf="tabKey === 'Photos'"
                                        title="Job Photos"
                                        [documentKey]="jobModel.jobCustomer.documentKey"
                                        [primaryJobDocumentKey]="jobModel.documentKey"
                                        documentType="Jobs"
                                        folderType="photos"
                                        getUrl="/documents/getAllJobPhotosForCustomer"
                                        [canDelete]="jobsAuthService.canEdit()"
                                        [allowTitleEditing]="jobsAuthService.canEdit()"
                                        [hideFileDrop]="true"></documents-edit>

                        <documents-edit *ngIf="tabKey === 'Photos'"
                                        title="Invoice Photos"
                                        [documentKey]="jobModel.jobCustomer.documentKey"
                                        documentType="Invoices"
                                        folderType="photos"
                                        getUrl="/documents/getAllInvoicePhotosForCustomer"
                                        [canDelete]="jobsAuthService.canEdit()"
                                        [allowTitleEditing]="jobsAuthService.canEdit()"
                                        [hideFileDrop]="true"></documents-edit>

                        <documents-edit *ngIf="tabKey === 'Photos'"
                                        title="Equipment Tracking Photos"
                                        [documentKey]="jobModel.documentKey"
                                        getUrl="/documents/GetAllEquipmentTrackingPhotosForJob"
                                        [referenceId]="jobModel.jobId"
                                        [excludeDocumentKey]="jobModel.documentKey"
                                        documentType="Jobs"
                                        folderType="photos"
                                        [canDelete]="false"
                                        [allowTitleEditing]="jobsAuthService.canEdit()"
                                        [hideFileDrop]="true"></documents-edit>
                    </slick-container-body>
                </slick-container>
            </slick-tab>

            <slick-tab header="Documents" icon="bi bi-file-earmark-text-fill" *ngIf="jobModel.jobId > 0">
                <slick-container maxHeight="calc(100vh - 280px)">
                    <slick-container-body>
                        <documents-edit *ngIf="tabKey === 'Documents'"
                                        [documentKey]="jobModel.documentKey"
                                        documentType="Jobs"
                                        title="Job Documents"
                                        folderType="documents"
                                        [canDelete]="jobsAuthService.canEdit()"
                                        [allowTitleEditing]="jobsAuthService.canEdit()"
                                        [hideFileDrop]="!jobsAuthService.canEdit()"></documents-edit>
                    </slick-container-body>
                </slick-container>
            </slick-tab>
            <slick-tab header="Text Chat" icon="bi bi-chat-left-text-fill" *ngIf="useTextChat && jobModel.jobId > 0 && jobModel.jobCustomer.customerId">
                <div style="min-height: calc(100vh - 290px); overflow: hidden">
                    <div *ngIf="!jobModel.jobCustomer.cellPhone && !jobModel.jobCustomer.homePhone" class="m-1">
                        No phone number entered for this customer
                    </div>
                    <text-chat-messages [isDialog]="true"></text-chat-messages>
                </div>
            </slick-tab>

            <slick-tab *ngIf="jobModel.jobId !== 0 && canAccessJobCosting" header="Job Costing" icon="bi-graph-up-arrow">
                <slick-container maxHeight="calc(100vh - 280px)">
                    <slick-container-body *ngIf="tabKey === 'Job Costing'">
                        <div *ngIf="isJobCostSetupValid">
                            <div *ngIf="!jobModel.jobCostingDetailModel">
                                <button class="btn btn-outline-primary" (click)="generateJobCostingReport()">Generate Job Costing Report</button>
                            </div>
                            <div *ngIf="jobModel.jobCostingDetailModel">
                                <button class="btn btn-outline-primary" (click)="generateJobCostingReport()">Regenerate Job Costing Report</button>
                            </div>
                        </div>
                        <job-costing-details [isValid]="isJobCostSetupValid" [jobCostingDetailModel]="jobModel.jobCostingDetailModel"></job-costing-details>
                    </slick-container-body>
                </slick-container>
            </slick-tab>

            <slick-tab header="Appt. History" icon="bi bi-clock-history" *ngIf="jobModel.jobId > 0 && !jobModel.showOneTimeAddress && showHistory">
                <slick-container maxHeight="calc(100vh - 280px)">
                    <slick-container-body>
                        <div *ngIf="customerJobHistory">
                            <ai-summary [customerId]="jobModel.jobCustomer?.customerId"></ai-summary>

                            <div class="mb-2 mt-2" style="width:300px">
                                <slick-search-bar [ngModel]="jobHistorySearchString" (onSearch)="onSearch($event)" [showAddButton]="false" [showEditButton]="false"></slick-search-bar>
                            </div>
                            <div *ngIf="customerJobHistory.length === 0">
                                No History to display
                            </div>

                            <div *ngIf="customerJobHistory.length > 0">
                                <div class="card card-body mb-2 p-2 pe-3 appointment-history-card" *ngFor="let jobHistory of customerJobHistory">
                                    <div class="resource-label appointment-history-header" style="font-size: 20px; flex-wrap: wrap;">
                                        <span class="border-0" style="font-weight: bold;">
                                            {{jobHistory.appointmentTypeDescription}}
                                        </span>

                                        <span style="margin-right: 10px; margin-left: 10px;">|</span>

                                        <span (click)="openJob(jobHistory.jobId)"
                                              [class.disabled]="!jobsAuthService.canEdit()"
                                              style="text-decoration: underline; cursor: pointer; color: blue;">
                                            {{jobHistory.jobName}}
                                        </span>

                                        <span style="margin-right: 13px; margin-left: 13px;">|</span>

                                        <span>{{jobHistory.jobSiteDisplayName}}</span>

                                        <div *ngIf="jobHistory.invoiceId"
                                             class="appt-history-invoice-info">

                                            <div>Invoice Information</div>

                                            <div style="font-size: 12px; font-weight: normal;">
                                                {{jobHistory.billingDisplayName}}
                                            </div>

                                            <div *ngIf="jobHistory.invoiceNumber"
                                                 style="font-size: 12px; font-weight: normal;">
                                                Invoice:
                                                <span (click)="openInvoicefromAppt(jobHistory.invoiceId)"
                                                      [class.disabled]="!jobsAuthService.canEdit()"
                                                      style="text-decoration: underline; cursor: pointer; color: blue;">
                                                    {{jobHistory.invoiceNumber}}
                                                </span>
                                            </div>

                                            <div style="font-size: 12px; font-weight: normal;">
                                                Total Cost ${{ jobHistory.invoiceTotal }}
                                            </div>
                                        </div>

                                        <span *ngIf="!jobHistory.invoiceId"
                                              style="margin-left: auto; font-size: 15px; font-weight: bold;">
                                            No Invoice
                                        </span>
                                    </div>

                                    <div class="resource-label">
                                        <div style="display: flex; align-items: left;">
                                            <span style="font-weight: bold;">{{ jobHistory.resourceName }}</span>

                                            <span *ngIf="jobHistory.crewDisplay"
                                                  style="margin-right: 13px; margin-left: 13px;">|</span>

                                            <span *ngIf="jobHistory.crewDisplay">
                                                {{jobHistory.crewDisplay}}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="resource-label">
                                        <div style="display: flex; align-items: left;">
                                            <span>{{ jobHistory.scheduledDateTime | date:'M/d/yy - h:mm a' }}</span>

                                            <span *ngIf="jobHistory.finishedTotalDisplay != '0:00'"
                                                  style="margin-right: 13px; margin-left: 13px;">|</span>

                                            <span *ngIf="jobHistory.finishedTotalDisplay != '0:00'">
                                                Total time: {{jobHistory.finishedTotalDisplay}}
                                            </span>
                                        </div>
                                        <div class="resource-label">
                                            <div style="display: flex; align-items: left;">
                                                <span>Status: {{ jobHistory?.appointmentStatusDisplayName }}</span>
                                                <ng-container *ngIf="jobHistory?.appointmentStatusReasonDisplayName">
                                                    <span class="separator" style="margin: 0 13px;">|</span>
                                                    <span>Reason: {{ jobHistory.appointmentStatusReasonDisplayName }}</span>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex mt-4 appointment-notes-row">
                                        <div class="flex-fill me-2" style="min-width: 33%; max-width: 33%; border-right: 2px solid var(--bs-gray-300);">
                                            <label class="job-label" style="font-size: .7rem;">Appointment instructions</label>
                                            <div class="ps-2 pe-1">
                                                {{ jobHistory.appointmentDescription }}
                                            </div>
                                        </div>
                                        <div class="flex-fill me-2" style="min-width: 33%; max-width: 33%; border-right: 2px solid var(--bs-gray-300);">
                                            <label class="job-label" style="font-size: .7rem;">Customer Notes</label>
                                            <div class="ps-2 pe-1">
                                                {{ jobHistory.appointmentCustomerNotes || 'No customer notes' }}
                                            </div>
                                        </div>
                                        <div class="flex-fill">
                                            <label class="job-label" style="font-size: .7rem;">Tech Notes</label>
                                            <div class="ps-2">
                                                {{ jobHistory.appointmentNotes }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slick-container-body>
                </slick-container>
            </slick-tab>

            <!-- Assets replaces the old Orenda and Equipment Tracking tabs: everything is recorded
                 against one of the customer's pools or spas now, so it's all reached through one. -->
            <slick-tab header="Assets" icon="bi bi-water" *ngIf="showAssets && jobModel.jobId > 0 && jobModel.jobCustomer?.customerId">
                <slick-container maxHeight="calc(100vh - 280px)">
                    <slick-container-body>
                        <assets *ngIf="assetsOpened" #assetsRef
                                [customerId]="jobModel.jobCustomer.customerId"
                                [jobId]="jobModel.jobId"
                                [documentKey]="jobModel.documentKey"></assets>
                    </slick-container-body>
                </slick-container>
            </slick-tab>

            <slick-tab [header]="rmaTabHeader" icon="bi bi-clipboard-x-fill" *ngIf="jobModel.jobId > 0 && rmaClaimsCount > 0">
                <slick-container maxHeight="calc(100vh - 250px)">
                    <slick-container-body>
                        <div class="p-3">
                            <div *ngFor="let claim of rmaClaims" class="card mb-3">
                                <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-3">
                                    <div>
                                        <strong>{{ claim.rmaNumber }}</strong>
                                        <span class="badge bg-dark ms-2">{{ claim.claimTypeDisplay || claim.claimType }}</span>
                                        <span class="badge ms-1"
                                              [ngClass]="claim.isClosed ? 'bg-secondary' : 'bg-warning text-dark'">
                                            {{ claim.statusDisplay || claim.status }}
                                        </span>
                                        <span *ngIf="claim.isClosed" class="badge bg-secondary ms-1">Closed</span>
                                        <span *ngIf="claim.isInternal" class="badge bg-info text-dark ms-1" title="Created from the tech Warranty Review button">Internal</span>
                                        <span *ngIf="!claim.isClosed" class="badge ms-1"
                                              [ngClass]="claim.isStale ? 'bg-danger' : 'bg-light text-dark'"
                                              [title]="claim.targetResolutionDays ? ('Target: ' + claim.targetResolutionDays + ' days') : ''">
                                            {{ claim.daysInStatus }}d in status
                                            <i *ngIf="claim.isStale" class="bi bi-exclamation-triangle-fill ms-1"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="card-body py-2 px-3">
                                    <div class="row g-2 small">
                                        <!-- Customer -->
                                        <div class="col-12 col-md-6" *ngIf="claim.customerName">
                                            <span class="text-muted">Customer:</span> {{ claim.customerName }}
                                        </div>
                                        <div class="col-12 col-md-6" *ngIf="claim.customerPhone || claim.customerEmail">
                                            <span class="text-muted">Contact:</span>
                                            {{ claim.customerPhone }}<span *ngIf="claim.customerPhone && claim.customerEmail"> · </span>{{ claim.customerEmail }}
                                        </div>
                                        <div class="col-12" *ngIf="claim.customerAddress">
                                            <span class="text-muted">Address:</span> {{ claim.customerAddress }}
                                        </div>

                                        <!-- Original order references -->
                                        <div class="col-6 col-md-3" *ngIf="claim.originalOrderNumber">
                                            <span class="text-muted">Order #:</span> {{ claim.originalOrderNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.originalInvoiceNumber">
                                            <span class="text-muted">Invoice #:</span> {{ claim.originalInvoiceNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.originalJobNumber">
                                            <span class="text-muted">Job #:</span> {{ claim.originalJobNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.originalInstallDate">
                                            <span class="text-muted">Installed:</span> {{ claim.originalInstallDate | date:'shortDate' }}
                                        </div>

                                        <!-- Builder / Distributor -->
                                        <div class="col-6 col-md-3" *ngIf="claim.builderName">
                                            <span class="text-muted">Builder:</span> {{ claim.builderName }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.distributorName">
                                            <span class="text-muted">Distributor:</span> {{ claim.distributorName }}
                                        </div>

                                        <!-- Latham / Mizu references -->
                                        <div class="col-6 col-md-3" *ngIf="claim.lathamRmaNumber">
                                            <span class="text-muted">Latham RMA #:</span> {{ claim.lathamRmaNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.lathamInvoiceNumber">
                                            <span class="text-muted">Latham Inv #:</span> {{ claim.lathamInvoiceNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.purchaseCreditMemoNumber">
                                            <span class="text-muted">Purchase Credit Memo #:</span> {{ claim.purchaseCreditMemoNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.salesCreditMemoNumber">
                                            <span class="text-muted">Sales Credit Memo #:</span> {{ claim.salesCreditMemoNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.mizuAuthorization">
                                            <span class="text-muted">Mizu Auth:</span> {{ claim.mizuAuthorization }}
                                        </div>

                                        <!-- Product -->
                                        <div class="col-6 col-md-3" *ngIf="claim.brand">
                                            <span class="text-muted">Brand:</span> {{ claim.brand }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.model">
                                            <span class="text-muted">Model:</span> {{ claim.model }}
                                        </div>

                                        <!-- Repair-specific -->
                                        <div class="col-6 col-md-3" *ngIf="claim.repairType">
                                            <span class="text-muted">Repair Type:</span> {{ claim.repairType }}
                                        </div>

                                        <!-- Warranty-specific -->
                                        <div class="col-6 col-md-3" *ngIf="claim.warrantyType">
                                            <span class="text-muted">Warranty Type:</span> {{ claim.warrantyType }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.warrantyComponent">
                                            <span class="text-muted">Component:</span> {{ claim.warrantyComponent }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.partNumber">
                                            <span class="text-muted">Part #:</span> {{ claim.partNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.motorSerialNumber">
                                            <span class="text-muted">Motor Serial #:</span> {{ claim.motorSerialNumber }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.systemType">
                                            <span class="text-muted">System Type:</span> {{ claim.systemType }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.motorSide">
                                            <span class="text-muted">Motor Side:</span> {{ claim.motorSide }}
                                        </div>

                                        <!-- Return for Credit-specific -->
                                        <div class="col-6 col-md-3" *ngIf="claim.creditRequested">
                                            <span class="text-muted">Credit Requested:</span> {{ claim.creditRequested | currency }}
                                        </div>
                                        <div class="col-6 col-md-3" *ngIf="claim.restockFeePercent">
                                            <span class="text-muted">Restock Fee:</span> {{ claim.restockFeePercent }}%
                                        </div>

                                        <!-- People -->
                                        <div class="col-12 col-md-6">
                                            <span class="text-muted">Account Exec:</span> {{ claim.accountExecutiveUserName || '—' }}
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <span class="text-muted">Followers:</span> {{ claim.followerUserNames || '—' }}
                                        </div>

                                        <!-- Descriptions / notes -->
                                        <div class="col-12" *ngIf="claim.requestDescription">
                                            <span class="text-muted">Request:</span> {{ claim.requestDescription }}
                                        </div>
                                        <div class="col-12" *ngIf="claim.repairRequestDescription && claim.repairRequestDescription !== claim.requestDescription">
                                            <span class="text-muted">Repair Request:</span> {{ claim.repairRequestDescription }}
                                        </div>
                                        <div class="col-12" *ngIf="claim.issue">
                                            <span class="text-muted">Issue:</span> {{ claim.issue }}
                                        </div>
                                        <div class="col-12">
                                            <span class="text-muted">Office Notes:</span> {{ claim.officeNotes || '—' }}
                                        </div>

                                        <!-- Line items (Return for Credit) -->
                                        <div class="col-12" *ngIf="claim.lineItems?.length">
                                            <div class="text-muted mb-1">Line Items</div>
                                            <table class="table table-sm table-borderless mb-0">
                                                <thead>
                                                    <tr class="text-muted">
                                                        <th style="font-weight: normal;">SKU</th>
                                                        <th style="font-weight: normal;">Description</th>
                                                        <th class="text-end" style="font-weight: normal;">Qty</th>
                                                        <th class="text-end" style="font-weight: normal;">Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let li of claim.lineItems">
                                                        <td>{{ li.sku }}</td>
                                                        <td>{{ li.description }}</td>
                                                        <td class="text-end">{{ li.quantity }}</td>
                                                        <td class="text-end">{{ li.amount | currency }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <!-- Emails sent -->
                                        <div class="col-12 col-md-6" *ngIf="claim.emailedSalesRepAddress">
                                            <span class="text-muted">Emailed Sales Rep:</span> {{ claim.emailedSalesRepAddress }}
                                        </div>

                                        <!-- PDF -->
                                        <div class="col-12" *ngIf="claim.pdfUrl">
                                            <a [href]="claim.pdfUrl" target="_blank"><i class="bi bi-file-earmark-pdf"></i> View Claim PDF</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer py-1 px-3 d-flex justify-content-between flex-wrap gap-2 text-muted" style="font-size: 0.75rem;">
                                    <span>Created {{ claim.createdDate | date:'short' }}</span>
                                    <span *ngIf="claim.statusChangedDate">Status changed {{ claim.statusChangedDate | date:'short' }}</span>
                                    <span *ngIf="claim.lastModifiedDate">Modified {{ claim.lastModifiedDate | date:'short' }}</span>
                                    <span *ngIf="claim.isClosed && claim.closedDate">Closed {{ claim.closedDate | date:'short' }}<span *ngIf="claim.closedByUserName"> by {{ claim.closedByUserName }}</span></span>
                                </div>
                            </div>
                        </div>
                    </slick-container-body>
                </slick-container>
            </slick-tab>

            <slick-tab header="System Logs" icon="bi bi-info-circle-fill" *ngIf="jobModel.jobId > 0">
                <slick-container maxHeight="calc(100vh - 280px)">
                    <slick-container-body>
                        <system-logs *ngIf="tabKey === 'System Logs'" noteType="1" [referenceId]="jobModel.jobId"></system-logs>
                    </slick-container-body>
                </slick-container>
            </slick-tab>
        </slick-tabs>

    </slick-container-body>

    <slick-container-footer *ngIf="!isDialog">
        <div class="d-flex">
            <div class="flex-fill" *ngIf="jobsAuthService.canEdit()">
                <div class="mt-2 pt-2 mb-3 me-3" style="min-width: 100%">
                    <button class="save-button btn btn-outline-success me-3" style="width: 140px" (click)="saveJob()" [slick-button-spinner]="spinnerStatus"><i class="bi bi-check-circle"></i> Save</button>
                    <button class="cancel-button btn btn-outline-danger" style="width: 140px" (click)="cancelJob()"><i class="bi bi-x-circle"></i> Cancel</button>
                </div>
            </div>
            <div class="flex-fill" *ngIf="!jobsAuthService.canEdit()">
                <permission-denied [message]="'*You do not have permission to edit Jobs.'"></permission-denied>
            </div>
        </div>
    </slick-container-footer>
</div>

<site-log-dialog #siteLogDialogRef></site-log-dialog>
<auto-scheduler-dialog #autoSchedulerDialogRef></auto-scheduler-dialog>
<estimate-edit-dialog #estimateEditDialogRef></estimate-edit-dialog>
<sales-order-edit-dialog #salesOrderEditDialogRef></sales-order-edit-dialog>
<invoice-edit-dialog #invoiceEditDialogRef></invoice-edit-dialog>
<conflicting-appointments-dialog #conflictingApptDialogRef></conflicting-appointments-dialog>

<slick-confirm-dialog #createNewEstimateRef>
    No estimate exists for this job.  Do you want to create a new one?
</slick-confirm-dialog>

<slick-confirm-dialog #createNewSalesOrderRef>
    No sales order exists for this job.  Do you want to create a new one?
</slick-confirm-dialog>

<slick-confirm-dialog #createNewInvoiceRef>
    No invoice exists for this job.  Do you want to create a new one?
</slick-confirm-dialog>

<slick-confirm-dialog #overwriteInvoiceRef>
    <h4 class="p-0 m-0 text-danger" style="text-align: center">
        This job is already linked with {{this.jobModel?.invoice?.invoiceNumber}}.&nbsp;
        <span *ngIf='isEstimate'>Linking a new Quote will overwrite this.</span>
        <span *ngIf='isSalesOrder'>Linking a new sales order will overwrite this.</span>
        <span *ngIf='isInvoice'>Linking a new invoice will overwrite this.</span>

        Are you sure you want to re-link?
    </h4>
</slick-confirm-dialog>

<slick-confirm-dialog #invoiceIsOnExistingJobRef>
    <h4 class="p-0 m-0 text-danger" style="text-align: center">
        This invoice is already linked with a job.
        Are you sure you want to remove it from the existing job?
    </h4>
</slick-confirm-dialog>

<slick-dialog #deleteInvoiceDialogRef width="300" (onClose)="doNotDeleteInvoice()">
    <h4 class="p-0 m-0" style="text-align:center">
        Would you like to delete the invoice linked to this job as well?
    </h4>
    <slick-container-footer>
        <div class="d-flex justify-content-center border-top mt-4 pt-2">
            <div>
                <button class="save-button btn btn-outline-primary me-3" style="width: 100px" (click)="deleteLinkedInvoice()"><i class="far fa-check"></i> Yes</button>
                <button class="cancel-button btn btn-outline-danger" style="width: 100px" (click)="doNotDeleteInvoice()"><i class="bi bi-x-circle"></i> No</button>
            </div>
        </div>
    </slick-container-footer>
</slick-dialog>

<slick-dialog #linkInvoiceDialogRef [resizable]="false" [draggable]="false" [minimizable]="false" header="Select Invoice" width="560">

    <div class="input-group mt-3" style="width: 530px">
        <span class="input-group-text"><i class="far fa-search"></i></span>
        <input (keyup)="refreshLinkInvoices()" [(ngModel)]="linkInvoiceSearchString" class="form-control" placeholder="Invoice/PO Number..." />
    </div>
    <div class="my-1">
        <input type="checkbox" [(ngModel)]="showClosedLinkInvoices" (change)="refreshLinkInvoices()" /> Show Closed Invoices
    </div>

    <div style="min-height: calc(100vh - 380px); max-height: calc(100vh - 380px); overflow-y: auto;">
        <div *ngIf="visibleLinkInvoices && visibleLinkInvoices.length === 0" class="mt-3">No sales orders or invoices available to link</div>
        <div *ngIf="visibleLinkInvoices && visibleLinkInvoices.length > 0" class="d-flex flex-column">
            <div *ngFor="let linkInvoice of visibleLinkInvoices" class="border-bottom px-1 mt-1 pb-1 me-2 d-flex" style="line-height: 1.1rem;">
                <div class="d-flex flex-fill flex-column">
                    <h5 class="m-0 p-0 border-0">
                        <span *ngIf='linkInvoice.isSalesOrder'>Sales Order #: </span>
                        <span *ngIf='!linkInvoice.isSalesOrder'>Invoice #: </span>
                        {{linkInvoice.invoiceNumber}}
                    </h5>
                    <div>PO #:{{linkInvoice.purchaseOrderNumber}}</div>
                    <div>
                        <span *ngIf='linkInvoice.isSalesOrder'>Sales Order Date: </span>
                        <span *ngIf='!linkInvoice.isSalesOrder'>Invoice Date: </span>
                        {{linkInvoice.invoiceDate | date:'M/d/yyyy'}}
                    </div>
                    <div>
                        <span *ngIf='linkInvoice.isSalesOrder'>Sales Order Total: </span>
                        <span *ngIf='!linkInvoice.isSalesOrder'>Invoice Total: </span>
                        {{linkInvoice.invoiceTotal | currency}}
                    </div>
                </div>
                <div>
                    <button class="btn btn-sm btn-primary" (click)="selectInvoiceToLink(linkInvoice)"><i class="far fa-link"></i> Select</button>
                </div>
            </div>
        </div>
    </div>
</slick-dialog>

<slick-dialog #addToPipelineDialogRef [resizable]="false" [minimizable]="false" header="Add to Sales Pipeline" width="420">
    <slick-container-body>
        <div class="mt-2" *ngIf="pipelineItems.length > 1">
            <label>Pipeline</label>
            <slick-drop-down [(ngModel)]="addToPipelineId" [items]="pipelineItems" (ngModelChange)="onAddToPipelineChanged()"></slick-drop-down>
        </div>
        <div class="mt-2">
            <label>Column</label>
            <slick-drop-down [(ngModel)]="addToPipelineStageId" [items]="pipelineStageItems" placeholder="Choose a column"></slick-drop-down>
            <form-error *ngIf="addToPipelineSubmitted && !addToPipelineStageId">Choose which column the ticket goes in</form-error>
        </div>
        <div class="mt-2">
            <label>Title</label>
            <input class="form-control" [(ngModel)]="addToPipelineTitle" />
        </div>
        <div *ngIf="addToPipelineError" class="text-danger mt-2">{{addToPipelineError}}</div>
    </slick-container-body>
    <slick-container-footer>
        <div class="d-flex justify-content-center border-top mt-3 pt-2">
            <button class="save-button btn btn-outline-success me-3" style="width: 140px" (click)="createPipelineTicket()" [slick-button-spinner]="addToPipelineSpinner"><i class="bi bi-check-circle"></i> Create</button>
            <button class="cancel-button btn btn-outline-danger" style="width: 140px" (click)="addToPipelineDialogRef.hideDialog()"><i class="bi bi-x-circle"></i> Cancel</button>
        </div>
    </slick-container-footer>
</slick-dialog>

<slick-dialog #oneTimeAddressDialogRef [resizable]="true" [draggable]="true" [minimizable]="true" header="Job Site Address" width="450">
    <slick-container-body>
        <div class="d-flex flex-column" *ngIf="addressModel">
            <div>
                <div class="flex-fill mt-2">
                    <label>Address 1</label>
                    <input class="form-control"
                           [slick-validation-indicator]="addressModel.address1"
                           slickValidationType="error"
                           [(ngModel)]="addressModel.address1" />
                </div>
                <form-error *ngIf="!addressModel.address1 && isSubmitted">The Job Site Address is required</form-error>
            </div>

            <div>
                <div class="flex-fill mt-2">
                    <label>Address 2</label>
                    <input class="form-control"
                           [(ngModel)]="addressModel.address2" />
                </div>
            </div>

            <div>
                <div class="flex-fill mt-2">
                    <label>City</label>
                    <input class="form-control"
                           [(ngModel)]="addressModel.city" />
                </div>
            </div>
            <div class="d-flex">
                <div class="flex-fill me-2 mt-2">
                    <div *ngIf="addressModel.country !== 'Canada'">
                        <label>State</label>
                        <input class="form-control"
                               [(ngModel)]="addressModel.state" />
                    </div>

                    <div *ngIf="addressModel.country === 'Canada'">
                        <label>Province</label>
                        <input class="form-control"
                               [(ngModel)]="addressModel.state" />
                    </div>
                </div>

                <div class="flex-fill me-2 mt-2">
                    <label>Zipcode</label>
                    <input class="form-control"
                           [(ngModel)]="addressModel.zipcode" />
                </div>

                <div class="flex-fill mt-2">
                    <label>Country</label>
                    <slick-drop-down [(ngModel)]="addressModel.country"
                                     [items]="countries"></slick-drop-down>
                </div>
            </div>
        </div>
    </slick-container-body>

    <slick-container-footer>
        <div class="d-flex justify-content-center border-top mt-4 pt-2">
            <div>
                <button class="save-button btn btn-outline-success me-3" style="width: 140px" (click)="saveOneTimeAddress()"><i class="bi bi-check-circle"></i> Save</button>
                <button class="cancel-button btn btn-outline-danger" style="width: 140px" (click)="cancelOneTimeAddress()"><i class="bi bi-x-circle"></i> Cancel</button>
            </div>
        </div>
    </slick-container-footer>

</slick-dialog>
<slick-dialog top="50" [header]="jobModelForDialog?.jobName" width="920" #jobEditDialogRef (onClose)="cancelDialogJob()">
    <job-edit *ngIf="jobModelForDialog" #jobEditComponentRef [jobModel]="jobModelForDialog" [defaultApptId]="defaultApptId" isDialog="true" [showHistory]="false" [showAssets]="false"></job-edit>
    <slick-dialog-footer>
        <button class="save-button btn btn-outline-success me-3" style="width: 160px" (click)="saveDialogJob()" [slick-button-spinner]="spinnerDialogStatus">
            <i class="bi bi-check-circle"></i> Save
        </button>
        <button class="cancel-button btn btn-outline-danger" style="width: 160px" (click)="cancelDialogJob()">
            <i class="bi bi-x-circle"></i> Cancel
        </button>

    </slick-dialog-footer>
</slick-dialog>